export default __webpack_public_path__ + "static/featured-image-d55c8a5c41f00a6d6ca4f955d9908a98.jpg";